// translations.js — MDD i18n translation dictionary
// Core UI labels only. User-entered data is never translated.
// Fallback: English if key missing in selected language.

const translations = {
  en: {
    // Navigation
    "nav.dashboard": "Dashboard",
    "nav.allDebits": "All Debits",
    "nav.settings": "Settings",
    "nav.add": "Add",

    // Dashboard
    "dashboard.hello": "Hello",
    "dashboard.stayInControl": "Stay in control",
    "dashboard.thisMonth": "This Month",
    "dashboard.paymentTracked": "payment tracked",
    "dashboard.paymentsTracked": "payments tracked",
    "dashboard.estimatedBalance": "Estimated Available Balance",
    "dashboard.afterUpcoming": "After upcoming payments this month",
    "dashboard.estimate": "Estimate",
    "dashboard.overdraftWarning": "You may go into your overdraft or incur fees which could apply.",
    "dashboard.largestUpcoming": "Largest Upcoming",
    "dashboard.next7Days": "Next 7 Days",
    "dashboard.noUpcoming7": "No upcoming payments in the next 7 days",
    "dashboard.upcomingPayments": "Upcoming Payments",
    "dashboard.noDebits": "No direct debits yet",
    "dashboard.addFirst": "Add your first direct debit to start tracking",
    "dashboard.addDebit": "Add Direct Debit",
    "dashboard.dueToday": "Due today",
    "dashboard.dueInDays": "Due in {days} days",

    // Auth
    "auth.welcomeBack": "Welcome Back",
    "auth.createAccount": "Create Account",
    "auth.signIn": "Sign In",
    "auth.signUp": "Sign Up",
    "auth.signInToContinue": "Sign in to continue",
    "auth.signUpToStart": "Sign up to get started",
    "auth.fullName": "Full Name",
    "auth.emailAddress": "Email Address",
    "auth.password": "Password",
    "auth.forgotPassword": "Forgot Password?",
    "auth.newHere": "New here?",
    "auth.createFreeAccount": "Create Your Free Account",
    "auth.takesLess30": "Takes less than 30 seconds. No card required.",
    "auth.alreadyHaveAccount": "Already have an account?",
    "auth.quickCheck": "Quick check: What is",
    "auth.yourAnswer": "Your answer",

    // Settings
    "settings.title": "Settings",
    "settings.profile": "Profile",
    "settings.preferences": "Preferences",
    "settings.defaultCurrency": "Default Currency",
    "settings.appLanguage": "App Language",
    "settings.useDeviceLanguage": "Use device/browser language",
    "settings.balanceEstimate": "Balance Estimate",
    "settings.balanceHelper": "Used only to estimate your available balance. You can update this anytime.",
    "settings.monthlyIncome": "Total Monthly Income",
    "settings.payDate": "Date Paid Into Account",
    "settings.overdraftBalance": "Overdraft Balance",
    "settings.optional": "optional",
    "settings.balanceDisclaimer": "This is only an estimate. Actual bank balances may differ. MDD does not connect to your bank.",
    "settings.subscription": "Subscription",
    "settings.restorePremium": "Restore Premium",
    "settings.upgradePremium": "Upgrade to Premium",
    "settings.unlimitedDebits": "Unlimited direct debits",
    "settings.support": "Support",
    "settings.financialSupport": "Financial Support & Grants",
    "settings.leaveFeedback": "Leave Feedback",
    "settings.writeReview": "Write a Review",
    "settings.legal": "Legal",
    "settings.privacyPolicy": "Privacy Policy",
    "settings.termsOfService": "Terms of Service",
    "settings.cookiePolicy": "Cookie Policy",
    "settings.account": "Account",
    "settings.exportData": "Export My Data",
    "settings.deleteAccount": "Delete Account",
    "settings.logout": "Log Out",

    // Common
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.loading": "Loading...",
    "common.goToDashboard": "Go to Dashboard",
    "common.getStartedFree": "Get Started Free",
    "common.readMore": "Read More",
    "common.saved": "Saved!",

    // Add/Edit Debit
    "debit.addTitle": "Add Direct Debit",
    "debit.editTitle": "Edit Direct Debit",
    "debit.companyName": "Company / Service Name",
    "debit.amount": "Amount",
    "debit.paymentDay": "Payment Day",
    "debit.frequency": "Frequency",
    "debit.notes": "Notes",
    "debit.monthly": "Monthly",
    "debit.weekly": "Weekly",
    "debit.biWeekly": "Bi-weekly",
    "debit.quarterly": "Quarterly",
    "debit.annually": "Annually",
    "debit.setupReminder": "Set Up Reminder",
  },

  es: {
    "nav.dashboard": "Panel",
    "nav.allDebits": "Todos los Débitos",
    "nav.settings": "Ajustes",
    "nav.add": "Añadir",
    "dashboard.hello": "Hola",
    "dashboard.stayInControl": "Mantén el control",
    "dashboard.thisMonth": "Este Mes",
    "dashboard.paymentTracked": "pago registrado",
    "dashboard.paymentsTracked": "pagos registrados",
    "dashboard.estimatedBalance": "Saldo Estimado Disponible",
    "dashboard.afterUpcoming": "Después de los pagos de este mes",
    "dashboard.estimate": "Estimación",
    "dashboard.overdraftWarning": "Podría entrar en descubierto o incurrir en comisiones.",
    "dashboard.largestUpcoming": "Mayor Próximo",
    "dashboard.next7Days": "Próximos 7 Días",
    "dashboard.noUpcoming7": "Sin pagos próximos en los siguientes 7 días",
    "dashboard.upcomingPayments": "Próximos Pagos",
    "dashboard.noDebits": "Aún no hay débitos directos",
    "dashboard.addFirst": "Añade tu primer débito directo para comenzar",
    "dashboard.addDebit": "Añadir Débito Directo",
    "dashboard.dueToday": "Vence hoy",
    "dashboard.dueInDays": "Vence en {days} días",
    "auth.welcomeBack": "Bienvenido",
    "auth.createAccount": "Crear Cuenta",
    "auth.signIn": "Iniciar Sesión",
    "auth.signUp": "Registrarse",
    "auth.signInToContinue": "Inicia sesión para continuar",
    "auth.signUpToStart": "Regístrate para empezar",
    "auth.fullName": "Nombre Completo",
    "auth.emailAddress": "Correo Electrónico",
    "auth.password": "Contraseña",
    "auth.forgotPassword": "¿Olvidaste tu contraseña?",
    "auth.newHere": "¿Eres nuevo?",
    "auth.createFreeAccount": "Crea Tu Cuenta Gratis",
    "auth.takesLess30": "Menos de 30 segundos. Sin tarjeta.",
    "auth.alreadyHaveAccount": "¿Ya tienes cuenta?",
    "auth.quickCheck": "Verificación rápida: ¿Cuánto es",
    "auth.yourAnswer": "Tu respuesta",
    "settings.title": "Ajustes",
    "settings.profile": "Perfil",
    "settings.preferences": "Preferencias",
    "settings.defaultCurrency": "Moneda Predeterminada",
    "settings.appLanguage": "Idioma de la App",
    "settings.useDeviceLanguage": "Usar idioma del dispositivo",
    "settings.balanceEstimate": "Estimación de Saldo",
    "settings.balanceHelper": "Solo se usa para estimar tu saldo disponible. Puedes actualizarlo en cualquier momento.",
    "settings.monthlyIncome": "Ingresos Mensuales Totales",
    "settings.payDate": "Fecha de Pago en Cuenta",
    "settings.overdraftBalance": "Saldo de Descubierto",
    "settings.optional": "opcional",
    "settings.balanceDisclaimer": "Esto es solo una estimación. Los saldos bancarios reales pueden diferir. MDD no se conecta a tu banco.",
    "settings.subscription": "Suscripción",
    "settings.restorePremium": "Restaurar Premium",
    "settings.upgradePremium": "Mejorar a Premium",
    "settings.unlimitedDebits": "Débitos directos ilimitados",
    "settings.support": "Soporte",
    "settings.legal": "Legal",
    "settings.privacyPolicy": "Política de Privacidad",
    "settings.termsOfService": "Términos de Servicio",
    "settings.cookiePolicy": "Política de Cookies",
    "settings.account": "Cuenta",
    "settings.exportData": "Exportar Mis Datos",
    "settings.deleteAccount": "Eliminar Cuenta",
    "settings.logout": "Cerrar Sesión",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.delete": "Eliminar",
    "common.edit": "Editar",
    "common.loading": "Cargando...",
    "common.goToDashboard": "Ir al Panel",
    "common.saved": "¡Guardado!",
    "debit.addTitle": "Añadir Débito Directo",
    "debit.editTitle": "Editar Débito Directo",
    "debit.companyName": "Nombre de Empresa / Servicio",
    "debit.amount": "Importe",
    "debit.paymentDay": "Día de Pago",
    "debit.frequency": "Frecuencia",
    "debit.notes": "Notas",
    "debit.monthly": "Mensual",
    "debit.weekly": "Semanal",
    "debit.biWeekly": "Quincenal",
    "debit.quarterly": "Trimestral",
    "debit.annually": "Anual",
    "debit.setupReminder": "Configurar Recordatorio",
  },

  fr: {
    "nav.dashboard": "Tableau de Bord",
    "nav.allDebits": "Tous les Prélèvements",
    "nav.settings": "Paramètres",
    "nav.add": "Ajouter",
    "dashboard.hello": "Bonjour",
    "dashboard.stayInControl": "Gardez le contrôle",
    "dashboard.thisMonth": "Ce Mois",
    "dashboard.paymentTracked": "paiement suivi",
    "dashboard.paymentsTracked": "paiements suivis",
    "dashboard.estimatedBalance": "Solde Estimé Disponible",
    "dashboard.afterUpcoming": "Après les paiements à venir ce mois",
    "dashboard.estimate": "Estimation",
    "dashboard.overdraftWarning": "Vous pourriez être à découvert ou encourir des frais.",
    "dashboard.largestUpcoming": "Plus Gros à Venir",
    "dashboard.next7Days": "7 Prochains Jours",
    "dashboard.noUpcoming7": "Aucun paiement prévu dans les 7 prochains jours",
    "dashboard.upcomingPayments": "Paiements à Venir",
    "dashboard.noDebits": "Pas encore de prélèvements",
    "dashboard.addFirst": "Ajoutez votre premier prélèvement pour commencer",
    "dashboard.addDebit": "Ajouter un Prélèvement",
    "dashboard.dueToday": "Dû aujourd'hui",
    "dashboard.dueInDays": "Dû dans {days} jours",
    "auth.welcomeBack": "Bon Retour",
    "auth.createAccount": "Créer un Compte",
    "auth.signIn": "Se Connecter",
    "auth.signUp": "S'inscrire",
    "auth.signInToContinue": "Connectez-vous pour continuer",
    "auth.signUpToStart": "Inscrivez-vous pour commencer",
    "auth.fullName": "Nom Complet",
    "auth.emailAddress": "Adresse Email",
    "auth.password": "Mot de Passe",
    "auth.forgotPassword": "Mot de passe oublié ?",
    "auth.newHere": "Nouveau ici ?",
    "auth.createFreeAccount": "Créez Votre Compte Gratuit",
    "auth.takesLess30": "Moins de 30 secondes. Sans carte.",
    "auth.alreadyHaveAccount": "Vous avez déjà un compte ?",
    "auth.quickCheck": "Vérification rapide : Combien font",
    "auth.yourAnswer": "Votre réponse",
    "settings.title": "Paramètres",
    "settings.profile": "Profil",
    "settings.preferences": "Préférences",
    "settings.defaultCurrency": "Devise par Défaut",
    "settings.appLanguage": "Langue de l'App",
    "settings.useDeviceLanguage": "Utiliser la langue de l'appareil",
    "settings.balanceEstimate": "Estimation du Solde",
    "settings.monthlyIncome": "Revenu Mensuel Total",
    "settings.payDate": "Date de Versement en Compte",
    "settings.overdraftBalance": "Solde de Découvert",
    "settings.optional": "facultatif",
    "settings.balanceDisclaimer": "Ceci n'est qu'une estimation. Les soldes bancaires réels peuvent différer. MDD ne se connecte pas à votre banque.",
    "settings.subscription": "Abonnement",
    "settings.restorePremium": "Restaurer Premium",
    "settings.account": "Compte",
    "settings.exportData": "Exporter Mes Données",
    "settings.deleteAccount": "Supprimer le Compte",
    "settings.logout": "Se Déconnecter",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.delete": "Supprimer",
    "common.edit": "Modifier",
    "common.saved": "Enregistré !",
    "debit.addTitle": "Ajouter un Prélèvement",
    "debit.editTitle": "Modifier le Prélèvement",
    "debit.companyName": "Nom de l'Entreprise / Service",
    "debit.amount": "Montant",
    "debit.paymentDay": "Jour de Paiement",
    "debit.frequency": "Fréquence",
    "debit.notes": "Notes",
    "debit.monthly": "Mensuel",
    "debit.weekly": "Hebdomadaire",
    "debit.biWeekly": "Bimensuel",
    "debit.quarterly": "Trimestriel",
    "debit.annually": "Annuel",
    "debit.setupReminder": "Configurer un Rappel",
  },

  pt: {
    "nav.dashboard": "Painel",
    "nav.allDebits": "Todos os Débitos",
    "nav.settings": "Configurações",
    "nav.add": "Adicionar",
    "dashboard.hello": "Olá",
    "dashboard.stayInControl": "Mantenha o controle",
    "dashboard.thisMonth": "Este Mês",
    "dashboard.paymentTracked": "pagamento rastreado",
    "dashboard.paymentsTracked": "pagamentos rastreados",
    "dashboard.estimatedBalance": "Saldo Estimado Disponível",
    "dashboard.afterUpcoming": "Após os pagamentos deste mês",
    "dashboard.estimate": "Estimativa",
    "dashboard.overdraftWarning": "Você pode entrar no cheque especial ou incorrer em taxas.",
    "dashboard.largestUpcoming": "Maior Próximo",
    "dashboard.next7Days": "Próximos 7 Dias",
    "dashboard.noUpcoming7": "Sem pagamentos nos próximos 7 dias",
    "dashboard.upcomingPayments": "Pagamentos Futuros",
    "dashboard.noDebits": "Ainda sem débitos diretos",
    "dashboard.addFirst": "Adicione seu primeiro débito para começar",
    "dashboard.addDebit": "Adicionar Débito Direto",
    "auth.signIn": "Entrar",
    "auth.signUp": "Registrar",
    "auth.forgotPassword": "Esqueceu a senha?",
    "settings.title": "Configurações",
    "settings.appLanguage": "Idioma do App",
    "settings.useDeviceLanguage": "Usar idioma do dispositivo",
    "settings.account": "Conta",
    "settings.exportData": "Exportar Meus Dados",
    "settings.deleteAccount": "Excluir Conta",
    "settings.logout": "Sair",
    "common.save": "Salvar",
    "common.cancel": "Cancelar",
    "common.delete": "Excluir",
    "common.saved": "Salvo!",
    "debit.addTitle": "Adicionar Débito Direto",
    "debit.amount": "Valor",
    "debit.monthly": "Mensal",
    "debit.weekly": "Semanal",
    "debit.annually": "Anual",
  },

  ar: {
    "nav.dashboard": "لوحة التحكم",
    "nav.allDebits": "جميع الديون",
    "nav.settings": "الإعدادات",
    "nav.add": "إضافة",
    "dashboard.hello": "مرحبا",
    "dashboard.stayInControl": "ابق متحكماً",
    "dashboard.thisMonth": "هذا الشهر",
    "dashboard.paymentTracked": "دفعة مسجلة",
    "dashboard.paymentsTracked": "دفعات مسجلة",
    "dashboard.estimatedBalance": "الرصيد المتاح المقدر",
    "dashboard.afterUpcoming": "بعد المدفوعات القادمة هذا الشهر",
    "dashboard.estimate": "تقدير",
    "dashboard.overdraftWarning": "قد تدخل في السحب على المكشوف أو تتحمل رسوماً.",
    "dashboard.largestUpcoming": "الأكبر القادم",
    "dashboard.next7Days": "الأيام السبعة القادمة",
    "dashboard.upcomingPayments": "المدفوعات القادمة",
    "dashboard.noDebits": "لا توجد ديون مباشرة بعد",
    "dashboard.addDebit": "إضافة خصم مباشر",
    "auth.signIn": "تسجيل الدخول",
    "auth.signUp": "إنشاء حساب",
    "auth.forgotPassword": "نسيت كلمة المرور؟",
    "settings.title": "الإعدادات",
    "settings.appLanguage": "لغة التطبيق",
    "settings.useDeviceLanguage": "استخدام لغة الجهاز",
    "settings.account": "الحساب",
    "settings.exportData": "تصدير بياناتي",
    "settings.deleteAccount": "حذف الحساب",
    "settings.logout": "تسجيل الخروج",
    "common.save": "حفظ",
    "common.cancel": "إلغاء",
    "common.delete": "حذف",
    "common.saved": "تم الحفظ!",
    "debit.addTitle": "إضافة خصم مباشر",
    "debit.amount": "المبلغ",
    "debit.monthly": "شهري",
    "debit.weekly": "أسبوعي",
    "debit.annually": "سنوي",
  },

  pl: {
    "nav.dashboard": "Panel",
    "nav.allDebits": "Wszystkie Polecenia",
    "nav.settings": "Ustawienia",
    "nav.add": "Dodaj",
    "dashboard.hello": "Cześć",
    "dashboard.stayInControl": "Zachowaj kontrolę",
    "dashboard.thisMonth": "Ten Miesiąc",
    "dashboard.paymentTracked": "płatność śledzona",
    "dashboard.paymentsTracked": "płatności śledzonych",
    "dashboard.estimatedBalance": "Szacunkowe Dostępne Saldo",
    "dashboard.afterUpcoming": "Po nadchodzących płatnościach w tym miesiącu",
    "dashboard.estimate": "Szacunek",
    "dashboard.overdraftWarning": "Możesz wejść w debet lub ponieść opłaty.",
    "dashboard.largestUpcoming": "Największa Nadchodząca",
    "dashboard.next7Days": "Następne 7 Dni",
    "dashboard.upcomingPayments": "Nadchodzące Płatności",
    "dashboard.noDebits": "Brak poleceń zapłaty",
    "dashboard.addDebit": "Dodaj Polecenie Zapłaty",
    "auth.signIn": "Zaloguj się",
    "auth.signUp": "Zarejestruj się",
    "auth.forgotPassword": "Zapomniałeś hasła?",
    "settings.title": "Ustawienia",
    "settings.appLanguage": "Język Aplikacji",
    "settings.useDeviceLanguage": "Użyj języka urządzenia",
    "settings.account": "Konto",
    "settings.exportData": "Eksportuj Moje Dane",
    "settings.deleteAccount": "Usuń Konto",
    "settings.logout": "Wyloguj się",
    "common.save": "Zapisz",
    "common.cancel": "Anuluj",
    "common.delete": "Usuń",
    "common.saved": "Zapisano!",
    "debit.addTitle": "Dodaj Polecenie Zapłaty",
    "debit.monthly": "Miesięczny",
    "debit.weekly": "Tygodniowy",
    "debit.annually": "Roczny",
  },

  ro: {
    "nav.dashboard": "Panou",
    "nav.allDebits": "Toate Debitele",
    "nav.settings": "Setări",
    "nav.add": "Adaugă",
    "dashboard.hello": "Bună",
    "dashboard.stayInControl": "Păstrați controlul",
    "dashboard.thisMonth": "Luna Aceasta",
    "dashboard.estimatedBalance": "Sold Estimat Disponibil",
    "dashboard.estimate": "Estimare",
    "dashboard.overdraftWarning": "Este posibil să intrați în descoperit de cont sau să suportați comisioane.",
    "auth.signIn": "Conectare",
    "auth.signUp": "Înregistrare",
    "auth.forgotPassword": "Ați uitat parola?",
    "settings.title": "Setări",
    "settings.appLanguage": "Limba Aplicației",
    "settings.useDeviceLanguage": "Folosiți limba dispozitivului",
    "settings.account": "Cont",
    "settings.logout": "Deconectare",
    "common.save": "Salvare",
    "common.cancel": "Anulare",
    "common.saved": "Salvat!",
    "debit.monthly": "Lunar",
    "debit.weekly": "Săptămânal",
    "debit.annually": "Anual",
  },

  ur: {
    "nav.dashboard": "ڈیش بورڈ",
    "nav.allDebits": "تمام ڈیبٹ",
    "nav.settings": "ترتیبات",
    "nav.add": "شامل کریں",
    "dashboard.hello": "ہیلو",
    "dashboard.stayInControl": "کنٹرول میں رہیں",
    "dashboard.thisMonth": "اس مہینے",
    "dashboard.estimatedBalance": "تخمینی دستیاب بیلنس",
    "dashboard.estimate": "تخمینہ",
    "dashboard.overdraftWarning": "آپ اوور ڈرافٹ میں جا سکتے ہیں یا فیس لاگو ہو سکتی ہے۔",
    "auth.signIn": "سائن ان",
    "auth.signUp": "سائن اپ",
    "auth.forgotPassword": "پاسورڈ بھول گئے؟",
    "settings.title": "ترتیبات",
    "settings.appLanguage": "ایپ کی زبان",
    "settings.useDeviceLanguage": "ڈیوائس کی زبان استعمال کریں",
    "settings.account": "اکاؤنٹ",
    "settings.logout": "لاگ آؤٹ",
    "common.save": "محفوظ کریں",
    "common.saved": "محفوظ ہو گیا!",
    "debit.monthly": "ماہانہ",
    "debit.weekly": "ہفتہ وار",
    "debit.annually": "سالانہ",
  },

  hi: {
    "nav.dashboard": "डैशबोर्ड",
    "nav.allDebits": "सभी डेबिट",
    "nav.settings": "सेटिंग्स",
    "nav.add": "जोड़ें",
    "dashboard.hello": "नमस्ते",
    "dashboard.stayInControl": "नियंत्रण में रहें",
    "dashboard.thisMonth": "इस महीने",
    "dashboard.estimatedBalance": "अनुमानित उपलब्ध शेष",
    "dashboard.estimate": "अनुमान",
    "dashboard.overdraftWarning": "आप ओवरड्राफ्ट में जा सकते हैं या शुल्क लग सकता है।",
    "auth.signIn": "साइन इन",
    "auth.signUp": "साइन अप",
    "auth.forgotPassword": "पासवर्ड भूल गए?",
    "settings.title": "सेटिंग्स",
    "settings.appLanguage": "ऐप की भाषा",
    "settings.useDeviceLanguage": "डिवाइस भाषा का उपयोग करें",
    "settings.account": "खाता",
    "settings.logout": "लॉग आउट",
    "common.save": "सहेजें",
    "common.saved": "सहेजा गया!",
    "debit.monthly": "मासिक",
    "debit.weekly": "साप्ताहिक",
    "debit.annually": "वार्षिक",
  },

  sw: {
    "nav.dashboard": "Dashibodi",
    "nav.allDebits": "Malipo Yote",
    "nav.settings": "Mipangilio",
    "nav.add": "Ongeza",
    "dashboard.hello": "Habari",
    "dashboard.stayInControl": "Dhibiti fedha zako",
    "dashboard.thisMonth": "Mwezi Huu",
    "dashboard.estimatedBalance": "Salio Inayokadiriwa",
    "dashboard.estimate": "Makadirio",
    "dashboard.overdraftWarning": "Unaweza kuingia katika overdraft au kulipa ada.",
    "auth.signIn": "Ingia",
    "auth.signUp": "Jisajili",
    "auth.forgotPassword": "Umesahau nenosiri?",
    "settings.title": "Mipangilio",
    "settings.appLanguage": "Lugha ya Programu",
    "settings.useDeviceLanguage": "Tumia lugha ya kifaa",
    "settings.account": "Akaunti",
    "settings.logout": "Ondoka",
    "common.save": "Hifadhi",
    "common.saved": "Imehifadhiwa!",
    "debit.monthly": "Kila Mwezi",
    "debit.weekly": "Kila Wiki",
    "debit.annually": "Kila Mwaka",
  },

  // Auto-detected only (not in dropdown)
  yo: {
    "nav.dashboard": "Pánẹ́ẹ̀lì",
    "nav.allDebits": "Gbogbo Owó Àbọ̀",
    "nav.settings": "Ètò",
    "dashboard.hello": "Ẹ kú",
    "dashboard.thisMonth": "Oṣù Yìí",
    "auth.signIn": "Wọlé",
    "auth.signUp": "Forúkọ Sílẹ̀",
    "settings.title": "Ètò",
    "settings.logout": "Jáde",
  },

  ig: {
    "nav.dashboard": "Pánẹl",
    "nav.allDebits": "Ụgwọ Niile",
    "nav.settings": "Ntọala",
    "dashboard.hello": "Nnọọ",
    "dashboard.thisMonth": "Ọnwa A",
    "auth.signIn": "Banye",
    "auth.signUp": "Debanye Aha",
    "settings.title": "Ntọala",
    "settings.logout": "Pụọ",
  },

  tw: {
    "nav.dashboard": "Panɛl",
    "nav.allDebits": "Sika Nyinaa",
    "nav.settings": "Nhyehyɛe",
    "dashboard.hello": "Maakye",
    "dashboard.thisMonth": "Bosome Yi",
    "auth.signIn": "Bra Mu",
    "auth.signUp": "Kyerɛw Din",
    "settings.title": "Nhyehyɛe",
    "settings.logout": "Fi Mu",
  },
};

// Language display names and codes
export const LANGUAGES = [
  { code: "auto", name: "Use device/browser language" },
  { code: "en", name: "English" },
  { code: "es", name: "Español" },
  { code: "fr", name: "Français" },
  { code: "pt", name: "Português" },
  { code: "ar", name: "العربية" },
  { code: "pl", name: "Polski" },
  { code: "ro", name: "Română" },
  { code: "ur", name: "اردو" },
  { code: "hi", name: "हिन्दी" },
  { code: "sw", name: "Kiswahili" },
];

// Detect browser language, return matching code or 'en'
export function detectBrowserLanguage() {
  const browserLang = navigator.language || navigator.userLanguage || 'en';
  const code = browserLang.split('-')[0].toLowerCase();
  if (translations[code]) return code;
  return 'en';
}

// Get resolved language code (handles 'auto')
export function resolveLanguage(preference) {
  if (!preference || preference === 'auto') {
    return detectBrowserLanguage();
  }
  return translations[preference] ? preference : 'en';
}

// Translation lookup function
export function t(key, lang, replacements = {}) {
  const resolved = resolveLanguage(lang);
  let text = translations[resolved]?.[key] || translations.en?.[key] || key;
  for (const [k, v] of Object.entries(replacements)) {
    text = text.replace(`{${k}}`, v);
  }
  return text;
}

export default translations;
